if (!customElements.get('scroll-progress-bar')) {
  customElements.define('scroll-progress-bar', class ScrollProgressBar extends HTMLElement {
    connectedCallback() {
      // Run setup once. Re-parenting below re-enters this callback; the guard skips it.
      if (this._init) return;
      this._init = true;

      // Re-parent to <body> so a transformed/overflow ancestor can't break position:fixed
      // (Shopify wraps sections in containers that may clip or transform).
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this.fill = this.querySelector('.scroll-progress-bar__fill');
      // The header/menu chrome to sit beneath. `.header-wrapper` is present whether or not
      // the sticky header is enabled; its bottom tracks the announcement bar at the top of
      // the page and the pinned menu once scrolled.
      this.header =
        document.querySelector('.header-wrapper') ||
        document.querySelector('.section-header') ||
        document.querySelector('header');

      this.update = () => {
        const h = document.documentElement;
        const max = h.scrollHeight - h.clientHeight;
        const pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
        if (this.fill) this.fill.style.width = pct + '%';
        // Pin just below the header chrome currently at the top; 0 once it has scrolled away.
        if (this.header) {
          const bottom = this.header.getBoundingClientRect().bottom;
          this.style.top = (bottom > 0 ? bottom : 0) + 'px';
        }
      };

      this.onScroll = () => requestAnimationFrame(this.update);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.update();
    }

    disconnectedCallback() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    }
  });
}
